var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"concurs",staticClass:"concurs"},[_c('Intro',{class:{show: _vm.screen==='intro'}}),_c('Icebreaker',{class:{show: _vm.screen==='icebreaker'},on:{"goToIntro":function($event){_vm.screen='intro'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }